import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../services/user.service';
import { PowerBIService } from '../services/powerBI.service'
import { MatDialog } from '@angular/material/dialog';
import { MaskDialog } from '../mask/mask-dailog.component';

const msalConfig = {
  auth: {
    clientId: "cfb6ae3f-8397-4f18-865f-a48028d09695",
    authority: "https://login.microsoftonline.com/93f33571-550f-43cf-b09f-cd331338d086",
  },
  cache: {
    cacheLocation: "localStorage",
  }
};

const msalRequest = {
  scopes: ["https://analysis.windows.net/powerbi/api/.default"],
};

const ssoRequest = {
  loginHint: ''
};

@Component({
  selector: 'app-get-power-bi',
  templateUrl: './get-power-bi.component.html',
  styleUrls: ['./get-power-bi.component.css']
})
export class GetPowerBIComponent implements OnInit, OnDestroy {
  private $user: Subscription;
  user: any
  msalInstance: any
  allDatasets: any[] = []

  constructor(
    public dialog: MatDialog,
    private powerBIService: PowerBIService,
    private userService: UserService
  ) { }
  accessToken = ''
  dataSetID = ''
  tableName = ''
  selectedDatasets = null
  isLoading = true;
  retrySignInTimes = 0;
  ngOnInit(): void {
    this.$user = this.userService.user$.subscribe(data => {
      if (Array.isArray(data) && data.length) {
        ssoRequest.loginHint = data[0].username;

        this.msalInstance = new (window as any).Msal.UserAgentApplication(msalConfig);
        this.signIn().then(() => {
          this.getDroupAndDataset();
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.$user.unsubscribe();
  }

  signIn() {
    return new Promise((resolve: any, reject: any) => {
      if (this.msalInstance.getAccount()) {
        resolve();
      } else {
        this.msalInstance.ssoSilent(ssoRequest).then(() => {
          resolve();
        }).catch((err) => {
          console.log(err);
          if (this.retrySignInTimes < 3) {
            this.retrySignInTimes++;
            this.signIn().then(() => {
              this.retrySignInTimes = 0;
              resolve();
            }).catch(() => {
              reject();
            });
          } else {
            reject();
          }
        });
      }
    });
  }

  getPowerBI(): void {
    this.openDialog()
    document.getElementById('PowerBIresult').innerHTML = ''
    this.signIn().then(() => {
      this.getAccessToken();
    });
  }
  getAccessToken() {
    this.msalInstance
      .acquireTokenSilent(msalRequest)
      .then((res) => {
        console.log(res);
        this.accessToken = res.accessToken
        let query = { "queries": [{ "query": "EVALUATE TOPN(10, '" + this.tableName.replace(/^\s+|\s+$/g, "") + "')" }], "serializerSettings": { "includeNulls": true } }
        this.powerBIService.getPowBIData(this.dataSetID.replace(/^\s+|\s+$/g, ""), query, this.accessToken).then((res) => {
          document.getElementById('PowerBIresult').innerHTML = this.syntaxHighlight(res)
          this.dialog.getDialogById('addGroupMaskD').componentInstance.data.showClose = true
        }, (err) => { document.getElementById('PowerBIresult').innerHTML = this.syntaxHighlight(err); this.dialog.getDialogById('addGroupMaskD').componentInstance.data.showClose = true })
      }).catch((err) => {
        document.getElementById('PowerBIresult').innerHTML = this.syntaxHighlight(err)
        this.dialog.getDialogById('addGroupMaskD').componentInstance.data.showClose = true
      })
  }
  openDialog() {
    this.dialog.open(MaskDialog, {
      id: 'addGroupMaskD',
      height: '240px',
      width: '250px',
      disableClose: true,
      data: {
        showClose: false,
        message: '',
        marginLeft: '35%',
        fatherID: ''
      }
    });
  }

  syntaxHighlight(json) {
    if (typeof json != 'string') {
      json = JSON.stringify(json, undefined, 2);
    }
    json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      var cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    });
  }

  getDroupAndDataset() {
    this.msalInstance
      .acquireTokenSilent(msalRequest)
      .then((res) => {
        this.accessToken = res.accessToken
        this.powerBIService.getPowBIGroups(this.accessToken).then((resGroup) => {
          if (resGroup['value'] && resGroup['value'].length > 0) {
            let datasetsArr = [];
            let count = 0;
            resGroup['value'].forEach(group => {
              let groupId = group.id;
              this.powerBIService.getDatasetsByGroupid(groupId, this.accessToken).then((resDatasets) => {
                count++;
                if (resDatasets['value'] && resDatasets['value'].length > 0) {
                  resDatasets['value'].forEach(dataset => {
                    let datasetObj = {
                      id: dataset.id,
                      label: group.name + " -> " + dataset.name + " -> " + dataset.id,
                      groupId: group.id,
                      groupName: group.name,
                      datasetId: dataset.id,
                      datasetName: dataset.name
                    }
                    datasetsArr.push(datasetObj)
                  });
                }
                if (count == resGroup['value'].length) {
                  datasetsArr = datasetsArr.sort(function (s1, s2) {
                    return s1.label.toLowerCase() < s2.label.toLowerCase() ? -1 : 1;
                  });
                  this.allDatasets = datasetsArr;
                  this.isLoading = false;
                }
              })
            });
          } else {
            this.isLoading = false;
          }
        }, (err) => { })
      }).catch((err) => {

      })
  }

  onChange() {
    this.dataSetID = this.selectedDatasets;
  }

}
